<template>
  <div v-if="count > 0 || running">
    <v-sheet
      color="primary"
      dark
      rounded
      class="d-flex align-center flex-wrap px-4 py-2 mx-4 mb-2"
    >
      <v-icon class="me-2">mdi-checkbox-multiple-marked-outline</v-icon>
      <span class="font-weight-medium">
        {{ $t('n_selected', { count: count }) }}
      </span>

      <v-spacer></v-spacer>

      <!-- while a run is going, the actions give way to progress -->
      <template v-if="running">
        <span class="me-3 text-caption">
          {{ $t('bulk_progress', { done: done, total: total }) }}
        </span>
        <v-progress-circular
          indeterminate
          size="20"
          width="2"
        ></v-progress-circular>
      </template>

      <template v-else>
        <slot></slot>
        <v-btn text small @click="$emit('clear')">
          {{ $t('clear_selection') }}
        </v-btn>
      </template>
    </v-sheet>

    <v-progress-linear
      v-if="running"
      :value="progress"
      color="primary"
      height="3"
      class="mx-4 mb-2"
    ></v-progress-linear>
  </div>
</template>

<script>
/*
 * The bar that appears above a table once rows are selected. The parent passes
 * its selection count and run state in, and puts its own action buttons in the
 * default slot.
 */
export default {
  name: "BulkActionBar",
  props: {
    count: { type: Number, default: 0 },
    running: { type: Boolean, default: false },
    done: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    progress: { type: Number, default: 0 },
  },
};
</script>
